// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => ("static/js/" + chunkId + "." + {"120":"3cf3eb51","719":"f71dc8cc"}[chunkId] + ".chunk.js");